export enum JourneyStatus {
  new = 'NEW',
  draft = 'DRAFT',
  saved = 'SAVED',
  published = 'PUBLISHED',
  completed = 'COMPLETED',
  deleted = 'DELETED',
}
